import { useEffect } from "react";
import { useAbility } from "@casl/react";
import { AbilityContext } from "context/Ability";

import { useAppDispatch, useAppSelector } from "app/hooks";
import { isEmpty } from "lodash";

import { fetchPaceReportStatus, getReportStatus, getIsFetchingReportStatus } from "store/slice/Pace";
import { getBriefs } from "store/slice/Project/briefs/briefsSlice";
import { getInsights } from "store/slice/Project/insights/insightsSlice";
import { getProject, getProjectCompanyData } from "store/slice/Project/projectData/ProjectSlice";
import { getSearchAis } from "store/slice/Project/searchAis/searchAisSlice";

const useGetAssessmentStatus = (userId: number) => {
    const dispatch = useAppDispatch();
    const ability = useAbility(AbilityContext);
    const reportStatus = useAppSelector(getReportStatus);
    const isFetchingReportStatus = useAppSelector(getIsFetchingReportStatus);

    const { status: isFetchingProject } = useAppSelector(getProject);
    const { status: isFetchingInsight } = useAppSelector(getInsights);
    const { status: isFetchingBrief } = useAppSelector(getBriefs);
    const { status: isFetchingSearchAi } = useAppSelector(getSearchAis);
    const { status: isFetchingCompany } = useAppSelector(getProjectCompanyData);

    useEffect(() => {
        if (!userId) return;

        if (
            isEmpty(reportStatus) &&
            isFetchingReportStatus !== "fetching" &&
            isFetchingReportStatus !== "error" &&
            isFetchingProject !== "fetching" &&
            isFetchingInsight !== "fetching" &&
            isFetchingBrief !== "fetching" &&
            isFetchingSearchAi !== "fetching" &&
            isFetchingCompany !== "fetching" &&
            (ability.can("see", "PACE") ||
                ability.can("see", "PACE_ASSESSMENT") ||
                ability.can("see", "SAAS_PACE") ||
                ability.can("see", "SAAS_PACE_ASSESSMENT"))
        ) {
            dispatch(fetchPaceReportStatus(userId));
        }
    }, [
        ability,
        dispatch,
        isFetchingBrief,
        isFetchingCompany,
        isFetchingInsight,
        isFetchingProject,
        isFetchingReportStatus,
        isFetchingSearchAi,
        reportStatus,
        userId,
    ]);
};

export default useGetAssessmentStatus;
